import React, { useState } from "react";
import PropTypes from "prop-types";
import { Container, Row, Col } from "../../components/ui/wrapper";
import Text from "../../components/ui/text";
import { ListGroupWrap } from "./careers.style";
import List, { ListItem } from "../../components/ui/list";
import Heading from "../ui/heading";
import ApplyJobForm from "./ApplyJobForm";

const SingleCareerOverview = ({
  slug,
  title,
  details,
  description,
  pageContext,
  location,
  ...restProps
}) => {
  const {
    listItemStyle,
    textStyle,
    listStyle,
    headingStyle,
    descStyle
  } = restProps;

  return (
    <Container>
      <Row justify="center">
        <Col lg={8} {...descStyle}>
          <Text {...textStyle} dangerouslySetInnerHTML={{ __html: description }} />

          <Heading {...headingStyle}>About Us</Heading>
          {details.about && (
            <Text
              {...textStyle}
              dangerouslySetInnerHTML={{ __html: details.about }}
            />
          )}
          <Heading {...headingStyle}>Required skills: </Heading>
          <ListGroupWrap>
            {details.skills.required.map((data, index) => (
              <List {...listStyle} key={`aboutus-${index}`}>
                <ListItem>{data.title}</ListItem>
              </List>
            ))}
          </ListGroupWrap>

          <Heading {...headingStyle}>Good to Have: </Heading>
          <ListGroupWrap>
            {details.skills.desired.map((data, index) => (
              <List {...listStyle} key={`good-to-have-${index}`}>
                <ListItem>{data.title}</ListItem>
              </List>
            ))}
          </ListGroupWrap>
          <ApplyJobForm slug={slug} customFields={details?.custom} />
        </Col>
      </Row>
    </Container>
  );
};

SingleCareerOverview.propTypes = {};

SingleCareerOverview.defaultProps = {
  headingStyle: {
    fontSize: "26px",
    lineHeight: "36px",
    fontweight: 400,
    padding: "10px",
    pb: "10px"
  },
  descStyle: {
    pb: "65px",
    pt: "50px"
  },
  textStyle: {
    fontSize: "18px",
    lineHeight: "28px",
    pt: "20px",
    pb: "20px",
    mb: "0px"
  },
  listStyle: {
    layout: "circle",
    child: {
      fontSize: "18px"
    }
  }
};

export default SingleCareerOverview;
